export default __webpack_public_path__ + "static/media/bulsutalk_prev.5034fd86.jpg";